import { render, staticRenderFns } from "./BaseDatepicker.vue?vue&type=template&id=5bbf519b&"
import script from "./BaseDatepicker.vue?vue&type=script&lang=js&"
export * from "./BaseDatepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports